export const blockIconsContentPolicy = (
	<span className='material-symbols-outlined'>policy</span>
);
